import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-arrow-right-sm',
  templateUrl: './icon-arrow-right-sm.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowRightSmComponent {}
